module.exports = __webpack_public_path__ + "static/img/loading.7bf86e11.svg";